// Per-city map color rule for LINES ONLY (work site polylines/polygons, closure lines, detours).
// Pins, closure-type glyphs and point markers keep entityColor(). Driven by features.js `mapColorBy`:
//   absent / show:false  -> entity color (legacy, every other city)
//   mode: 'step'         -> colors[stepValue]
//   mode: 'impact'       -> colors[stepValue] first (e.g. planned), else the first checked Traffic Impact
//                           option, in the city's trafficImpact option order (= severity), else impactDefault.
// Option order (filters.js) also orders the legend; the flag's keys are integer-like and JS would sort them.
//   detour               -> detour arrows color, always, whatever the project's step or impact.
import Tags from './../shared/filters';
import Features from './../shared/features';

function flag(city) {
  const f = Features[city] && Features[city].mapColorBy;
  return f && f.show ? f : null;
}

function stepValue(project) {
  const s = project && project.informations && project.informations.step;
  return Array.isArray(s) ? s[0] : s;
}

function stepColor(project, f) {
  return (f.colors && f.colors[stepValue(project)]) || null;
}

function optionLabel(option, lang) {
  return (lang === 'fr' ? option.label_fr : option.label_en) || option.label;
}

export default {
  mode(city) {
    const f = flag(city);
    return f ? f.mode : null;
  },
  // Option value -> color map for a filter key ('step' or 'trafficImpact'), for the filter panel dots. {} otherwise.
  optionColors(city, key) {
    const f = flag(city);
    return (f && { step: f.colors, trafficImpact: f.impact }[key]) || {};
  },
  // Legacy lookup moved verbatim from MapPage/PublicPage getColorByEntity.
  entityColor(project, city, fallback, fromPublic) {
    const info = project && project.informations;
    const field = Tags[city] && Tags[city].entity;
    if (!info || !info.entity || !field) return fallback;
    const el = field.value.find(e => e.value == info.entity[0] && e.class);
    if (!el) return fallback;
    if (fromPublic && el.class1) el.class = el.class1.replace(' hidden', '');
    return field.classes[el.class] || fallback;
  },
  impactColor(project, city, f) {
    const data = project.informations && project.informations.trafficImpact;
    const checked = data && Array.isArray(data.value) ? data.value.filter(o => o.status) : [];
    const hit = Tags[city].trafficImpact.value.find(opt => f.impact[opt.value] && checked.some(o => o.value == opt.value));
    return hit ? f.impact[hit.value] : f.impactDefault;
  },
  projectColor(project, city, fallback, fromPublic) {
    const f = flag(city);
    if (!f) return this.entityColor(project, city, fallback, fromPublic);
    let color = stepColor(project, f);
    if (!color && f.mode === 'impact') color = this.impactColor(project, city, f);
    return color || fallback;
  },
  detourColor(city, projectColor) {
    const f = flag(city);
    return (f && f.detour) || projectColor;
  },
  // Rows for the public legend: [{label, color}], one row per color, labels from the city's option lists.
  legend(city, lang, detourLabel) {
    const f = flag(city);
    if (!f) return [];
    const rows = [];
    const byColor = (options, colors) => options.forEach((opt) => {
      const color = colors[opt.value];
      if (!color) return;
      const row = rows.find(r => r.color === color);
      row ? row.label += ' / ' + optionLabel(opt, lang) : rows.push({ label: optionLabel(opt, lang), color: color });
    });
    byColor(Tags[city].step.value, f.colors || {});
    if (f.mode === 'impact') {
      byColor(Tags[city].trafficImpact.value, f.impact);
      if (f.detour) rows.push({ label: detourLabel, color: f.detour });
    }
    return rows;
  }
};
